import React from 'react';
import { Button, Icon, Intent, ProgressBar, Tag, Text } from '@blueprintjs/core';
import { useDispatch, useSelector } from 'react-redux';
import { setInstallingExtension, clearInstallingExtension } from './extensions-actions';
import './extensions.css';
import { EXTENSION_ASSETS_URL } from '../../services/api';
import ActivityBarIcon2 from '../../components/ActivityBarIcon2';

const ExtensionIcon = ({ name }) => {
    const [iconReady, setIconReady] = React.useState(false);
    const [iconFailed, setIconFailed] = React.useState(false);

    const iconUrl = React.useMemo(() => {
        if (!name) return null;
        return `${EXTENSION_ASSETS_URL}/${name}/assets/${name}.svg`;
    }, [name]);

    React.useEffect(() => {
        if (!iconUrl) {
            setIconReady(false);
            setIconFailed(true);
            return;
        }

        let cancelled = false;
        setIconReady(false);
        setIconFailed(false);

        const img = new Image();
        img.onload = () => {
            if (!cancelled) {
                setIconReady(true);
                setIconFailed(false);
            }
        };
        img.onerror = () => {
            if (!cancelled) {
                setIconReady(false);
                setIconFailed(true);
            }
        };
        img.src = iconUrl;

        return () => {
            cancelled = true;
        };
    }, [iconUrl]);

    if (!iconUrl || iconFailed) {
        return <Icon icon="cube" size={40} intent="secondary" />;
    }

    if (!iconReady) {
        return <Icon icon="cube" size={40} intent="secondary" />;
    }

    return (
        <ActivityBarIcon2
            icon={iconUrl}
            size={40}
            onClick={() => {}}
        />
    );
};

const ResultItem = ({results, search, installedExtensions}) => {
    const [selected, setSelected] = React.useState(null);
    const [context, setContext] = React.useState(null);
    const dispatch = useDispatch();
    const { installingExtensionName, installingExtension } = useSelector(state => state.extensions);
    
    React.useEffect(() => {
        setContext(window['bodapro-context'])
    }, []);


    const isExtensionInstalled = (name) => {
        return (installedExtensions || []).indexOf(name) > -1
            || (globalThis['BODAPRO_EXTENSIONS'] || []).indexOf(name) > -1;
    }

  
  return (
    <div className="mb-20"> {installingExtensionName}
        {results?.filter && results.filter(v => {
            const p = new RegExp(search, 'gi');
            if (search === undefined) return true;
            if (search.length === 0) return true;
            if (p.test(v.name)) return true;
            return false;
        }).map((v, idx) => {
            const platformEntries = Array.isArray(v?.platform)
                ? v.platform
                : (typeof v?.platform === 'string'
                    ? v.platform.split(',').map(item => item.trim()).filter(Boolean)
                    : []);

            const normalizedPlatforms = platformEntries.map(platform => platform.toLowerCase());

            return (
        <div
            onClick={() => {
                context.addPanel({
                    id: 'extension-info',
                    title: v.label,
                    icon: 'cube',
                    componentName: 'extension-info',
                    groupId: 'main-panel',
                    params: {
                        'extension' : v.name,
                        
                    },
                    replacePanel: true
                });

                setSelected(v.name)
            }}
            style={{
                width: '100%',
                marginBottom: 10,
                hover: 'background-color: #f5f5f5'
            }}
            className={`extesion-search-result ${selected === v.name ? 'selected-result-item' : ''}`}
            key={idx}>
                <div style={{float: 'left'}} className="p-2">
                    <ExtensionIcon name={v.name} />
                </div>
                <div>
                    <div style={{display: 'flex', alignItems: 'center', gap: 6}}>
                        <span className="bp5-heading" style={{marginBottom: 0}}>{v.label}</span>
                        {isExtensionInstalled(v?.name) && <Tag minimal round>Installed</Tag>}
                    </div>
                    <div ><Text ellipsize>{v?.description}</Text></div>
                    <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 6}}>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                            <Text className="bp5-heading bp5-text-muted bp5-running-text mb-0">{v?.vendor}</Text>
                            {normalizedPlatforms.length > 0 && (
                                <span style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                                    {normalizedPlatforms.map(platform => (
                                        <Tag key={`${v.name}-${platform}`} minimal intent={Intent.PRIMARY} round>
                                            {platform}
                                        </Tag>
                                    ))}
                                </span>
                            )}
                        </div>
                        <div style={{flex: 1}} />
                        {/* <div>
                            {installingExtensionName !== v?.name && !isExtensionInstalled(v?.name) && !installedExtensions.indexOf(v?.name) > -1 && <Button icon="download" text="Install" small intent={Intent.PRIMARY} onClick={(e) => {
                                dispatch(setInstallingExtension(v.name));
                                e.stopPropagation();
                                e.preventDefault();
                            }}/>}
                            {installingExtensionName === v?.name && <Button icon="cross" text="Cancel" small intent={Intent.NONE} onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                dispatch(clearInstallingExtension());
                            }}/>}
                            
                        </div> */}
                        
                    </div>
                    {installingExtensionName === v?.name && <ProgressBar intent={Intent.PRIMARY}/>}
                </div>

        </div>
            );
        })}
    </div>
  );
}

export default ResultItem;